import type { Translations } from './en';
const appName = process.env.NEXT_PUBLIC_APP_NAME || 'MyApp';
const es: Translations = {
  common: {
    appName: appName,
    loading: 'Cargando...',
    save: 'Guardar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    delete: 'Eliminar',
    edit: 'Editar',
    back: 'Volver',
    search: 'Buscar',
    noResults: 'No se encontraron resultados',
    error: 'Ocurrió un error',
    success: 'Éxito',
  },
  header: {
    searchPlaceholder: 'Buscar noticias, temas, hashtags...',
    searchPlaceholderMobile: 'Buscar...',
    home: 'Inicio',
    hotgirl: 'Hotgirl',
    coser: 'Coser',
    model: 'Modelo',
    upload: 'Subir',
    notifications: 'Notificaciones',
    login: 'Iniciar sesión',
    register: 'Registrarse',
  },
  footer: {
    tagline: 'La mejor plataforma para compartir fotos de Coser, Hotgirl y Modelos.',
    copyright: `© {year} ${appName}. Todos los derechos reservados.`,
    sections: { explore: 'Explorar', account: 'Cuenta', support: 'Soporte' },
    links: {
      home: 'Inicio', hotgirl: 'Hotgirl', coser: 'Coser', model: 'Modelo', aoDai: 'Ao Dai',
      login: 'Iniciar sesión', register: 'Registrarse', upload: 'Subir foto', dashboard: 'Panel',
      terms: 'Términos de uso', privacy: 'Privacidad', report: 'Reportar violación', contact: 'Contacto',
    },
  },
  collections: {
    title: 'Colecciones',
    createAlbum: 'Crear álbum',
    saved: 'Guardados',
    noSaved: 'Aún no hay fotos guardadas',
    noSavedHint: 'Explorar fotos ahora →',
    removedSave: 'Eliminado de guardados',
    createModalTitle: 'Crear nuevo álbum',
    albumNamePlaceholder: 'Nombre del álbum...',
    cancel: 'Cancelar',
    create: 'Crear',
    albumCreated: 'Álbum creado',
  },
  home: {
    title: 'Descubre',
    titleHighlight: 'la belleza',
    titleSuffix: 'de vida',
    subtitle: 'Miles de fotos de Coser, Hotgirl y Modelos actualizadas cada día',
    sortNewest: 'Más recientes',
    sortTrending: 'Tendencias',
    sortPopular: 'Populares',
    allCategories: 'Todo',
    noMorePosts: 'Has visto todas las fotos',
  },
  auth: {
    login: {
      title: 'Inicia sesión para continuar',
      continueWithGoogle: 'Continuar con Google',
      orLoginWithEmail: 'o inicia sesión con tu correo',
      email: 'Correo electrónico',
      password: 'Contraseña',
      forgotPassword: '¿Olvidaste tu contraseña?',
      submitButton: 'Iniciar sesión',
      loading: 'Iniciando sesión...',
      noAccount: '¿No tienes cuenta?',
      registerLink: 'Regístrate ahora',
      errorCredentials: 'Correo o contraseña incorrectos',
      successLogin: '¡Sesión iniciada con éxito!',
    },
    register: {
      title: 'Crear una cuenta gratuita',
      displayName: 'Nombre de usuario',
      displayNamePlaceholder: 'Juan García',
      email: 'Correo electrónico',
      password: 'Contraseña',
      passwordPlaceholder: 'Al menos 8 caracteres',
      confirmPassword: 'Confirmar contraseña',
      submitButton: 'Registrarse',
      loading: 'Creando cuenta...',
      hasAccount: '¿Ya tienes una cuenta?',
      loginLink: 'Iniciar sesión',
      errorPasswordMismatch: 'Las contraseñas no coinciden',
      errorPasswordLength: 'La contraseña debe tener al menos 8 caracteres',
      errorGeneric: 'Error al registrarse',
      successRegister: '¡Registro exitoso!',
      emailTaken: 'El correo electrónico ya está en uso',
      serverError: 'Error del servidor, por favor intenta de nuevo más tarde',
    },
    forgotPassword: {
      title: 'Olvidé mi contraseña',
      subtitle: 'Ingresa tu correo y te enviaremos un enlace de restablecimiento',
      email: 'Correo electrónico',
      submitButton: 'Enviar enlace',
      backToLogin: 'Volver al inicio de sesión',
      sending: 'Enviando...',
      emailSent: '¡Email enviado!',
      checkEmail: 'Verifica la bandeja de entrada de {email} para recibir el enlace de restablecimiento de contraseña.',
      instructions: 'Ingresa tu email y te enviaremos un enlace para restablecer tu contraseña.',
    },
  },
  userMenu: {
    dashboard: 'Panel',
    collections: 'Colecciones',
    settings: 'Configuración',
    logout: 'Cerrar sesión',
  },
  settings: {
    title: 'Configuración de cuenta',
    profile: {
      nav: 'Perfil',
      title: 'Información del perfil',
      displayName: 'Nombre de usuario',
      username: 'Nombre de usuario',
      website: 'Sitio web',
      bio: 'Bio',
      bioPlaceholder: 'Preséntate...',
      changeAvatar: 'Cambiar avatar',
      avatarHint: 'JPG, PNG, WebP máx. 5MB',
      saveButton: 'Guardar cambios',
      saving: 'Guardando...',
      savedSuccess: 'Cambios guardados',
    },
    password: { 
      nav: 'Contraseña',
      title: 'Cambiar contraseña',
      fields: {
        currentPassword: 'Contraseña actual',
        newPassword: 'Nueva contraseña',
        confirm: 'Confirmar nueva contraseña',
      },
      errors: {
        confirm: 'La nueva contraseña no coincide',
        minLength: 'La contraseña debe tener al menos 8 caracteres',
      },
      success: 'Contraseña cambiada',
      saving: 'Guardando...',
      submit: 'Cambiar contraseña',
    },
    notifications: { 
      nav: 'Notificaciones',
      title: 'Configuración de notificaciones',
      options: {
        likes: 'Cuando alguien le gusta tu foto',
        comments: 'Cuando alguien comenta',
        replies: 'Cuando alguien responde a tu comentario',
        follows: 'Cuando alguien te sigue',
        approved: 'Cuando la publicación es aprobada',
        email_digest: 'Resumen semanal por correo electrónico',
        marketing: 'Notificaciones de promociones y eventos',
      },
      saveSuccess: 'Configuración de notificaciones guardada',
      saving: 'Guardando...',
      saveButton: 'Guardar configuración',
    },
    security: { 
      nav: 'Seguridad',
      twoFactorAuth: 'Autenticación de dos factores (2FA)',
      twoFactorAuthHint: 'Aumenta la seguridad con un código de verificación de la aplicación',
      comingSoon: 'Próximamente',
      activeSessions: 'Sesiones activas',
      currentBrowser: 'Navegador actual',
      lastLogin: 'Último inicio de sesión',
      active: 'Activo',
      dangerZone: 'Zona de peligro',
      deleteAccountHint: 'Eliminar la cuenta eliminará permanentemente todos sus datos.',
      deleteAccount: 'Eliminar cuenta',
    },
  },
  post: {
    likes: '{count} me gusta',
    views: '{count} vistas',
    shares: '{count} compartidos',
    comments: '{count} comentarios',
    save: 'Guardar',
    saved: 'Guardado',
    share: 'Compartir',
    linkCopied: '¡Enlace copiado!',
    follow: 'Seguir',
    following: 'Siguiendo',
    relatedPosts: 'Publicaciones relacionadas',
    commentPlaceholder: 'Escribe un comentario...',
    commentLoginPlaceholder: 'Inicia sesión para comentar...',
    commentSubmit: 'Publicar',
    commentSubmitting: 'Publicando...',
    noComments: 'Aún no hay comentarios. ¡Sé el primero!',
    savedToCollection: 'Guardado en colección',
    removedFromCollection: 'Eliminado de colección',
    description: 'Descripción',
    profileView: 'Ver perfil',
    replies: 'Respuestas',
    unsaved: 'Quitado de guardados',
    liked: 'Te gusta',
    like: 'Me gusta',
  },
  notifications: {
    title: 'Notificaciones',
    empty: 'No hay notificaciones',
    markAllRead: 'Marcar todo como leído',
    types: {
      like_post: 'ha gustado tu foto',
      comment: 'ha comentado tu foto',
      reply: 'ha respondido a tu comentario',
      follow: 'te ha seguido',
      approve: 'Tu publicación ha sido aprobada',
      reject: 'Tu publicación ha sido rechazada',
      system: 'Notificación del sistema',
    },
  },
  search: {
    title: 'Resultados de búsqueda para',
    result: 'Resultados',
    tryOtherKeywords: 'Prueba con otras palabras clave...',
    noResults: 'Sin resultados para',
    placeholder: 'Buscar...',
    thisHashtag: 'fotos con este hashtag',
    results: 'resultados',
  },
  upload: {
    title: 'Subir foto',
    dragDrop: 'Arrastra y suelta o haz clic para seleccionar',
    supportedFormats: 'Compatible con JPG, PNG, WebP, GIF',
    submit: 'Publicar',
    submitting: 'Publicando...',
    titleField: 'Título',
    cover: 'Portada',
    titlePlaceholder: 'Ingresa un título atractivo...',
    descriptionField: 'Descripción',
    descriptionPlaceholder: 'Descripción detallada del conjunto de fotos...',
    hashtagsField: 'Hashtags',
    statusField: 'Estado',
    statusPublic: 'Público',
    statusPrivate: 'Privado',
    statusDraft: 'Borrador',
    error: 'Error al subir',
    errorSelect: 'Selecciona al menos 1 foto',
    errorTitle: 'Ingresa un título',
    photos: 'fotos',
    uploading: 'Subiendo...',
  },
  notFound: {
    title: 'Página no encontrada',
    subtitle: 'La página que buscas no existe.',
    backHome: 'Volver al inicio',
  },
  liked: {
    title: 'Publicaciones que te gustan',
    empty: 'No has guardado ninguna publicación todavía.',
  },
  user: {
    unknown: 'Desconocido',
  },
  globalError: {
    title: 'Ocurrió un error',
    subtitle: 'Lo sentimos por el inconveniente. Por favor, inténtalo de nuevo.',
    retry: 'Reintentar',
  },
  username: {
    posts: 'Publicaciones',
    likes: 'Me gusta',
    followers: 'Seguidores',
    following: 'Siguiendo',
    editProfile: 'Editar perfil',
    message: 'Mensaje',
    noPosts: 'No hay publicaciones aún',
    bio: 'Ver fotos de ',
    notFound: 'Usuario no encontrado',
  },
  topic: {
    notFound: 'Tema no encontrado',
    viewTitle: 'Ver fotos del tema ',
  },
  dashboard: {
    title: 'Tablero',
    welcome: 'Bienvenido',
    stats: {
      posts: 'Publicaciones',
      views: 'Vistas',
      likes: 'Me gusta',
      comments: 'Comentarios',
    },
  },
  adsblock: {
    title: "Estás usando un bloqueador de anuncios",
    description: "Por favor, desactiva el bloqueador de anuncios para ver imágenes de alta calidad y ayudarnos a mantener el sitio web gratuito.",
    action: "Lo he desactivado — Recargar",
    cancel: "Omitir"
  },
  pwa: {
    title: `Instala ${appName} para una mejor experiencia`,
    iosSubtitle: 'Presiona Compartir → Agregar a la pantalla de inicio',
    androidSubtitle: 'Recibe notificaciones sobre nuevos conjuntos de fotos tan pronto como se publiquen',
    installButton: 'Instalar',
    disclaimer: 'Instalación rápida, no se requiere tienda de aplicaciones.',
  },
  autotrans: {
    title: 'Traducción automática',
    translated: 'Traducción',
    origin: 'Contenido original',
  },
  subscription: {
    title: 'Suscribirse a las Notificaciones',
    description: 'Recibe notificaciones sobre nuevos conjuntos de fotos tan pronto como se publiquen.',
    subscribeButton: 'Suscribirse',
    unsubscribeButton: 'Cancelar Suscripción',
    subscribed: 'Estás suscrito a las notificaciones.',
    unsubscribed: 'Te has dado de baja de las notificaciones.',
    error: 'Ocurrió un error al actualizar tu suscripción. Por favor, inténtalo de nuevo.',
    success_tit: '🎉 ¡Notificaciones Activadas!',
    denied_tit: 'Notificaciones Denegadas',
    error_tit: 'Ocurrió un Error',
    success_des: 'Recibirás notificaciones cuando haya nuevo contenido disponible.',
    denied_des: 'Puedes reactivarlas en la configuración de tu navegador.',
    error_des: 'Por favor, inténtalo de nuevo más tarde.',
    skip: 'Omitir',
    processing: 'Procesando...',
    noti: 'Activar Notificaciones',
    rule: 'Mostrar solo notificaciones para nuevo contenido.',
    notify_title: `Notificaciones - ${appName}`,
    notify_body: "La nueva galería ha sido publicada. ¡Échale un vistazo ahora!",
  },
  contact: {
    title: 'Contáctanos',
    subtitle: '¡Nos encantaría saber de ti! Por favor, completa el siguiente formulario y nos pondremos en contacto contigo lo antes posible.',
    name: 'Nombre',
    email: 'Correo electrónico',
    subject: 'Asunto',
    message: 'Mensaje',
    submitButton: 'Enviar mensaje',
    sending: 'Enviando...',
    successTitle: '¡Mensaje enviado!',
    successMessage: 'Gracias por ponerte en contacto. Nos comunicaremos contigo en breve.',
    errorTitle: 'Ocurrió un error',
    errorMessage: 'Hubo un error al enviar tu mensaje. Por favor, inténtalo de nuevo más tarde.',
    res_time_title: 'Tiempo de respuesta',
    res_time: 'Normalmente respondemos dentro de 1 a 3 días hábiles.',
    report_content: 'Reportar contenido',
    report_content_hint: 'Para reportar un post o usuario, utiliza el botón de reportar directamente en el contenido o selecciona “Reportar contenido” arriba.',
    value_default: 'Seleccionar un tema',
    value_general: 'Consulta general',
    value_report: 'Reportar contenido',
    value_account: 'Problema de cuenta',
    value_business: 'Negocios / asociación',
    value_feedback: 'Comentarios y sugerencias',
    value_other: 'Otro'
  },
  language: {
    label: 'Idioma',
    en: 'English', vi: 'Tiếng Việt', zh: '中文', ja: '日本語',
    ko: '한국어', ar: 'العربية', fr: 'Français', es: 'Español',
    ru: 'Русский',
    hi: 'हिन्दी',
    id: 'Indonesia',
    de: 'Deutsch',
    pt: 'Português',
    it: 'Italiano',
  },
};

export default es;
